export const IMAGE_BUCKET_URL = `${process.env.NEXT_PUBLIC_CONTENT_ASSETS_URL}/static/images`;
